import { FC } from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, TextFieldProps, Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';

export type RadioInputProps = TextFieldProps & {
  name: string;
  label: string;
  options: string[];
  //handleActivityStatusSelection: (activityId: string, status: ActivityStatus) => void;
  value?: string;
};

export const RadioGroupInput: FC<RadioInputProps> = ({ name, label, options, ...props }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  return (
    <FormControl fullWidth margin="normal">
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        name={name}
        row
        value={field.value}
        onChange={(event) => {
          setFieldValue(name, event.target.value);
        }}
      >
        <Stack spacing={1} direction="column">
          {options.map((option) => (
            <FormControlLabel key={option} control={<Radio checked={option === field.value} />} label={option} value={option} />
          ))}
        </Stack>
      </RadioGroup>
      {(meta.touched && meta.error) || props.error ? (
        <Typography variant="caption" color="error">
          {meta.error}
        </Typography>
      ) : null}
    </FormControl>
  );
};
